export const JEWELRY_PRODUCTION =
  "*Svaki proizvod izrađujemo sa posebnom pažnjom, pa je za njegovu izradu potrebno 7–10 radnih dana. Ako vam je proizvod potreban ranije, slobodno nas kontaktirajte putem e-maila ili telefona – moguće je da se željeni proizvod već nalazi na stanju.";

export const THANK_YOU_NOTE = "Hvala unapred na strpljenju!";
